const TOKEN_KEY = 'vocab_jwt'
const LEGACY_TOKEN_KEY = 'vacab_jwt'
const LEGACY_USER_ID_KEY = 'vocab_jwt_user_id'

export function migrateAuthStorage () {
  localStorage.removeItem(LEGACY_TOKEN_KEY)
  localStorage.removeItem(LEGACY_USER_ID_KEY)
}

export function getToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken (token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function clearAuthStorage () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(LEGACY_TOKEN_KEY)
  localStorage.removeItem(LEGACY_USER_ID_KEY)
}
